"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var icon_enum_1 = __importDefault(require("../../shared/enums/icon.enum"));
var convertToUpperSnakeCase_1 = __importDefault(require("../../shared/utilities/convertToUpperSnakeCase"));
var Icon = react_1.default.memo(function (props) {
    var getFAKey = function (icon) {
        var useGetKey = (0, convertToUpperSnakeCase_1.default)(icon);
        return icon_enum_1.default[useGetKey];
    };
    // check if Font Awesome
    var isFA = function (icon) { return Boolean(getFAKey(icon)); };
    if (!props.icon) {
        return null;
    }
    return isFA(props.icon) ? (react_1.default.createElement(__1.UxFaIcon, { className: props.className, icon: getFAKey(props.icon), size: props.size, squared: props.squared })) : (react_1.default.createElement(__1.UxImgIcon, { alt: ["avatar"].some(function (item) { var _a; return (_a = props.className) === null || _a === void 0 ? void 0 : _a.includes(item); }) ? "" : props.alt, className: props.className, icon: props.icon, size: props.size, squared: props.squared, title: props.title, theme: props.theme }));
});
exports.default = Icon;
